import { SearchOutlined } from "@ant-design/icons";
import { Pagination, Table } from "antd";
import { recordStringValue } from "src/common/utils/table";
import { globalVar, isNullOrUndefined } from "../../common/utils";
import { TableFilterController } from "../../pages/userGroups/listUserGroups/filterUserGroups/tableFilterController";
import { sendTableEvent, TableAction } from "../matomoClient";
import { SearchComponent } from "../searchComponent";
import "./index.scss";

export const defaultPageSize = 50;
export const defaultPageSizeOptions = ["25", "50", "100"];

function RenderTable(props) {
  return (
    <div>
      <Table {...props} />
      {props.isCustomPaginationRequired && props.loading === false && props.customPagination.total > 0? (
        <Pagination style={{ float: "right", paddingTop: "12px" }} {...props.customPagination} />
      ) : null}
    </div>
  );
}

export const AuthZTable = (props) => {
  const popupContainerProps = props.getPopupContainer
    ? { getPopupContainer: props.getPopupContainer }
    : {};
  props = {
    ...props,
    bordered: true,
    enableCustomSearchAndSort: true,
    displaySearchInPopup: props.displaySearchInPopup ?? true,
    onCustomFilterAndCustomSortChange:
      props.onCustomFilterAndCustomSortChange ?? ((_filter, _sort, _currentDataSource) => {}),
    isFilteredOrSortedInBackend: props.isFilteredOrSortedInBackend ?? false,
    isCustomPaginationRequired: props.isCustomPaginationRequired ?? false,
    ...popupContainerProps,
  };

  function makeSelectionColumnLast(columns) {
    return props.shouldMakeSelectionColumnLast === true
      ? [...columns, Table.SELECTION_COLUMN]
      : columns;
  }

  function addCustomPagination() {
    return {
      pagination: props.isCustomPaginationRequired ? false : props.pagination,
      customPagination: props.isCustomPaginationRequired ? props.pagination : null,
    };
  }

  const getColumnSearchProps = (title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, ...restProps }) => (
      <div
        style={{ padding: 8 }}
        onClick={() => sendTableEvent(TableAction.Search, props.name)}
      >
        <SearchComponent
          placeholder={title}
          text={selectedKeys[0]}
          onChange={(enteredTextValue) => {
            setSelectedKeys(enteredTextValue ? [enteredTextValue] : []);
            confirm(false); //Don't close dropdown
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#5F9FAB" : "black" }} />,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => globalVar.searchInput.focus(), 100);
      }
      sendTableEvent(TableAction.Filter, props.name);
    },
  });

  if (typeof props.columns != "undefined") {
    const columns = props.columns.map((column) => {
      let tempProps;
      let onFilter;

      if (column.searchEnabled === false) {
        tempProps = column;
      } else {
        tempProps = (props.enableCustomSearchAndSort) ? column : { ...column, ...getColumnSearchProps(column.title) };
        if (isNullOrUndefined(column.onFilter)) {
          onFilter = (value, record) => {
            let recordValue = recordStringValue(record, column.dataIndex);
            return recordValue ? recordValue.toLowerCase().includes(value.toLowerCase()) : "";
          };
        }
      }
      if (column.sortEnabled !== false) {
        if (isNullOrUndefined(column.sorter)) {
          tempProps = {
            ...tempProps,
            sorter: (recordA, recordB) => {
              let recordAValue = recordStringValue(recordA, column.dataIndex);
              let recordBValue = recordStringValue(recordB, column.dataIndex);
              return recordAValue.localeCompare(recordBValue);
            },
          };
        }
      }

      if (column.filterEnabled === true && isNullOrUndefined(column.onFilter)) {
        onFilter = (value, record) => {
          return record[column.dataIndex] === value;
        };
      }
      if (isNullOrUndefined(column.onFilter)) {
        return { ...tempProps, onFilter };
      }
      return { ...tempProps };
    });

    if (props.enableCustomSearchAndSort) {
      const { filteredData, updatedColumns } = TableFilterController(
        props.dataSource,
        columns,
        props.onCustomFilterAndCustomSortChange,
        props.displaySearchInPopup,
        props.isFilteredOrSortedInBackend,
        props.getPopupContainer
      );
      const newProps = {
        ...props,
        dataSource: filteredData,
        columns: makeSelectionColumnLast(updatedColumns),
        ...addCustomPagination(),
      };
      return <RenderTable {...newProps} />;
    } else {
      const newProps = {
        ...props,
        columns: makeSelectionColumnLast(columns),
        ...addCustomPagination(),
      };
      return <RenderTable {...newProps} />;
    }
  }
  const newProps = {
    ...props,
    columns: makeSelectionColumnLast(props.columns),
    ...addCustomPagination(),
  };
  return <RenderTable {...newProps} />;
};

